/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for stations search:
 *   * ALL : All fields
 *   * NAME : the station's name
 */
export enum NetworkSearchFilter {
  ALL = 'ALL',
  NAME = 'NAME'
}
